// extracted by mini-css-extract-plugin
module.exports = {"departments":"Ek-z","departmentHeading":"Fk-z","departmentSection":"Gk-z","departmentName":"Hk-z","departmentLink":"Ik-z","expandIcon":"Jk-z"};